//category
import imgflorsfamily from './images/family/flors-family.jpg';
import imghaschfamily from './images/family/hasch-family.jpg';

// indoor
import imgAmnesia from './images/fleurs/Amnesia.jpg';
import imgGelato from './images/fleurs/Gelato.jpg';
import imgZkittlez from './images/fleurs/Zkittlez.jpg';
import imgBlueberry from './images/fleurs/Blueberry.jpg';
import imgStrawberry from './images/fleurs/Strawberry.jpg';
import imgTrim from './images/fleurs/Trim.jpg';

// greenhouse
import imgCheese from './images/fleurs/Cheese.jpg';
import imgFruitCake from './images/fleurs/Fruit-Cake.jpg';

// hasch
import imgMarocain from './images/fleurs/Marocain.jpg';
import imgPollen from './images/fleurs/Pollen.jpg';
import imgFiltre from './images/fleurs/Filtre.jpg';
import imgiceOLator from './images/fleurs/iceOLator.jpg';

// Not use
import imgGP7 from './images/fleurs/GP7.jpg';
import imgBubblegum from './images/fleurs/Bubblegum.jpg';
import imgMango from './images/fleurs/Mango.jpg';
import imgHarlequin from './images/fleurs/Harlequin.jpg';
import imgHqCheese from './images/fleurs/HqCheese.jpg';
import imgKiss from './images/fleurs/Kiss.jpg';
import imgLimoncello from './images/fleurs/Limoncello.jpg';

import { mainDescription } from './mainDescription';

const SHOP_DATA = [
  {
    title: 'fleurs',
    imageFamily: imgflorsfamily,
    items: [
      {
        id: 1,
        name: 'Amnesia',
        categoryTitle: 'indoor',
        imageUrl: imgAmnesia,
        prices: [
          { value: 8.0, label: '1g (8,00€/g)' },
          { value: 35.0, label: '5g (7,00€/g)' },
          { value: 60.0, label: '10g (6,00€/g)' },
          { value: 137.0, label: '25g (5,48€/g)' },
          { value: 250.0, label: '50g (5,00€/g)' },
          { value: 470.0, label: '100g (4,70€/g)' }
        ],
        lowerPrice: 'A partir de 4,70€',
        mainDescription: mainDescription.amnesia,
        details: {
          cultureType: 'Indoor',
          country: 'Suisse',
          rateCBD: '5-7 %',
          rateTHC: '<0,3 %'
        },
        isFlorOrHasch: true
      },
      {
        id: 2,
        name: 'Gelato',
        categoryTitle: 'indoor',
        imageUrl: imgGelato,
        prices: [
          { value: 8.0, label: '1g (8,00€/g)' },
          { value: 35.0, label: '5g (7,00€/g)' },
          { value: 60.0, label: '10g (6,00€/g)' },
          { value: 137.0, label: '25g (5,48€/g)' },
          { value: 250.0, label: '50g (5,00€/g)' },
          { value: 470.0, label: '100g (4,70€/g)' }
        ],
        lowerPrice: 'A partir de 4,70€',
        mainDescription: mainDescription.gelato,
        details: {
          cultureType: 'Indoor',
          country: 'Suisse',
          rateCBD: '5-7 %',
          rateTHC: '<0,3 %'
        },
        isFlorOrHasch: true
      },
      {
        id: 3,
        name: 'Cereal Milk',
        categoryTitle: 'indoor',
        imageUrl: imgZkittlez,
        prices: [
          { value: 8.0, label: '1g (8,00€/g)' },
          { value: 35.0, label: '5g (7,00€/g)' },
          { value: 60.0, label: '10g (6,00€/g)' },
          { value: 137.0, label: '25g (5,48€/g)' },
          { value: 250.0, label: '50g (5,00€/g)' },
          { value: 470.0, label: '100g (4,70€/g)' }
        ],
        lowerPrice: 'A partir de 4,70€',
        mainDescription: mainDescription.cerealMilk,
        details: {
          cultureType: 'Indoor',
          country: 'Suisse',
          rateCBD: '12 %',
          rateTHC: '<0,3 %'
        },
        isFlorOrHasch: true
      },
      {
        id: 4,
        name: 'Biscotti',
        categoryTitle: 'indoor',
        imageUrl: imgBlueberry,
        prices: [
          { value: 8.0, label: '1g (8,00€/g)' },
          { value: 35.0, label: '5g (7,00€/g)' },
          { value: 60.0, label: '10g (6,00€/g)' },
          { value: 137.0, label: '25g (5,48€/g)' },
          { value: 250.0, label: '50g (5,00€/g)' },
          { value: 470.0, label: '100g (4,70€/g)' }
        ],
        lowerPrice: 'A partir de 4,70€',
        mainDescription: mainDescription.Biscotti,
        details: {
          cultureType: 'Indoor',
          country: 'Suisse',
          rateCBD: '11 %',
          rateTHC: '<0,3 %'
        },
        isFlorOrHasch: true
      },
      {
        id: 5,
        name: 'Tropical Dream',
        categoryTitle: 'indoor',
        imageUrl: imgStrawberry,
        prices: [
          { value: 8.0, label: '1g (8,00€/g)' },
          { value: 35.0, label: '5g (7,00€/g)' },
          { value: 60.0, label: '10g (6,00€/g)' },
          { value: 137.0, label: '25g (5,48€/g)' },
          { value: 250.0, label: '50g (5,00€/g)' },
          { value: 470.0, label: '100g (4,70€/g)' }
        ],
        lowerPrice: 'A partir de 4,70€',
        mainDescription: mainDescription.TropicalDream,
        details: {
          cultureType: 'Indoor',
          country: 'Suisse',
          rateCBD: '11 %',
          rateTHC: '<0,3 %'
        },
        isFlorOrHasch: true
      },
      {
        id: 6,
        name: 'Trim',
        categoryTitle: 'indoor',
        imageUrl: imgTrim,
        prices: [
          { value: 3.0, label: '1g (3,00€/g)' },
          { value: 12.5, label: '5g (2,50€/g)' },
          { value: 20.0, label: '10g (2,00€/g)' },
          { value: 37.5, label: '25g (1,50€/g)' },
          { value: 50.0, label: '50g (1,00€/g)' }
        ],
        lowerPrice: 'A partir de 1.00€',
        mainDescription: mainDescription.trimDescr,
        details: {
          cultureType: 'Indoor',
          country: 'Suisse',
          rateCBD: '3-5 %',
          rateTHC: '<0,3 %',
          taste: undefined
        },
        isFlorOrHasch: true
      },
      // {
      //   id: 412,
      //   name: 'BlueCheese',
      //   categoryTitle: 'indoor',
      //   imageUrl: imgBlueberry,
      //   prices: [
      //     { value: 7.0, label: '1g (7,00€/g)' },
      //     { value: 32.5, label: '5g (6,50€/g)' },
      //     { value: 60.0, label: '10g (6,00€/g)' },
      //     { value: 137.5, label: '25g (5,50€/g)' },
      //     { value: 250.0, label: '50g (5,00€/g)' },
      //     { value: 450.0, label: '100g (4,50€/g)' }
      //   ],
      //   lowerPrice: 'A partir de 4,50€',
      //   mainDescription: mainDescription.BlueCheeseDescr,
      //   details: {
      //     cultureType: 'Indoor',
      //     country: 'Suisse',
      //     rateCBD: '3-5%',
      //     rateTHC: '<0,3 %'
      //   },
      //   isFlorOrHasch: true
      // },
      // {
      //   id: 411,
      //   name: 'Bubblegum',
      //   categoryTitle: 'indoor',
      //   imageUrl: imgBubblegum,
      //   prices: [
      //     { value: 7.0, label: '1g (7,00€/g)' },
      //     { value: 32.5, label: '5g (6,50€/g)' },
      //     { value: 60.0, label: '10g (6,00€/g)' },
      //     { value: 137.5, label: '25g (5,50€/g)' },
      //     { value: 250.0, label: '50g (5,00€/g)' },
      //     { value: 450.0, label: '100g (4,50/g)' }
      //   ],
      //   lowerPrice: 'A partir de 4,50€',
      //   mainDescription: mainDescription.bubbleGumDescr,
      //   details: {
      //     cultureType: 'Indoor',
      //     country: 'Suisse',
      //     rateCBD: '7-8%',
      //     rateTHC: '<0,3 %'
      //   },
      //   isFlorOrHasch: true
      // },
      // {
      //   id: 410,
      //   name: 'Harlequin',
      //   categoryTitle: 'indoor',
      //   imageUrl: imgHarlequin,
      //   prices: [
      //     { value: 7.0, label: '1g (7,00€/g)' },
      //     { value: 32.5, label: '5g (6,50€/g)' },
      //     { value: 60.0, label: '10g (6,00€/g)' },
      //     { value: 137.5, label: '25g (5,50€/g)' },
      //     { value: 250.0, label: '50g (5,00€/g)' },
      //     { value: 450.0, label: '100g (4,50/g)' }
      //   ],
      //   lowerPrice: 'A partir de 4,50€',
      //   mainDescription: mainDescription.harlequinDescr,
      //   details: {
      //     cultureType: 'Indoor',
      //     country: 'Suisse',
      //     rateCBD: '7-8%',
      //     rateTHC: '<0,3 %'
      //   },
      //   isFlorOrHasch: true
      // },
      // {
      //   id: 408,
      //   name: 'Small Bud PREMIUM',
      //   categoryTitle: 'indoor',
      //   imageUrl: imgStrawberry,
      //   prices: [
      //     { value: 4.0, label: '1g (4,00€/g)' },
      //     { value: 15.0, label: '5g (3,00€/g)' },
      //     { value: 25.0, label: '10g (2,50€/g)' },
      //     { value: 56.25, label: '25g (2,25€/g)' },
      //     { value: 100.0, label: '50g (2,00€/g)' },
      //     { value: 180.0, label: '100g (1,80€/g)' }
      //   ],
      //   lowerPrice: 'A partir de 1,80€',
      //   mainDescription: mainDescription.strawberryDescr,
      //   details: {
      //     cultureType: 'Indoor',
      //     country: 'Suisse',
      //     rateCBD: '6-8%',
      //     rateTHC: '<0,3 %'
      //   },
      //   isFlorOrHasch: true
      // },
      {
        id: 7,
        name: 'OG Kush',
        categoryTitle: 'greenhouse',
        imageUrl: imgCheese,
        prices: [
          { value: 3.0, label: '1g (3,00€/g)' },
          { value: 15.0, label: '5g (3,00€/g)' },
          { value: 30.0, label: '10g (3,00€/g)' },
          { value: 75.0, label: '25g (3,00€/g)' },
          { value: 150.0, label: '50g (3,00€/g)' },
          { value: 300.0, label: '100g (3,00€/g)' }
        ],
        lowerPrice: 'A partir de 3,00€',
        mainDescription: mainDescription.ogKush,
        details: {
          cultureType: 'Greenhouse',
          country: 'Suisse',
          rateCBD: '9 %',
          rateTHC: '<0,3 %'
        },
        isFlorOrHasch: true
      },
      {
        id: 8,
        name: 'Lemon',
        categoryTitle: 'greenhouse',
        imageUrl: imgFruitCake,
        prices: [
          { value: 5.0, label: '1g (5,00€/g)' },
          { value: 25.0, label: '5g (5,00€/g)' },
          { value: 50.0, label: '10g (5,00€/g)' },
          { value: 125.0, label: '25g (5,00€/g)' },
          { value: 200.0, label: '50g (4,00€/g)' },
          { value: 300.0, label: '100g (3,00€/g)' }
        ],
        lowerPrice: 'A partir de 3,00€',
        mainDescription: mainDescription.fruitCake,
        details: {
          cultureType: 'Greenhouse',
          country: 'Suisse',
          rateCBD: '8 %',
          rateTHC: '<0,3 %'
        },
        isFlorOrHasch: true
      }
      // {
      //   id: 404,
      //   name: 'Kiss',
      //   categoryTitle: 'greenhouse',
      //   imageUrl: imgKiss,
      //   prices: [
      //     { value: 5.0, label: '1g (5,00€/g)' },
      //     { value: 20.0, label: '5g (4,00€/g)' },
      //     { value: 35.0, label: '10g (3,50€/g)' },
      //     { value: 75.0, label: '25g (3,00/g)' },
      //     { value: 100.0, label: '50g (2,00€/g)' },
      //     { value: 180.0, label: '100g (1,80€/g)' }
      //   ],
      //   lowerPrice: 'A partir de 1,80€',
      //   mainDescription: mainDescription.kiss,
      //   details: {
      //     cultureType: 'Green House',
      //     country: 'Italie',
      //     rateCBD: '3-5%',
      //     rateTHC: '<0,3 %'
      //   },
      //   isFlorOrHasch: true
      // },
      // {
      //   id: 403,
      //   name: 'Harlequin X cheese',
      //   categoryTitle: 'greenhouse',
      //   imageUrl: imgHqCheese,
      //   prices: [
      //     { value: 2.5, label: '1g (2,50€/g)' },
      //     { value: 12.5, label: '5g (2,50€/g)' },
      //     { value: 25.0, label: '10g (2,50€/g)' },
      //     { value: 56.25, label: '25g (2,25€/g)' },
      //     { value: 50.0, label: '50g (1,00€/g)' },
      //     { value: 100.0, label: '100g (1,00€/g)' }
      //   ],
      //   lowerPrice: 'A partir de 1,00€',
      //   mainDescription: mainDescription.HqCheeseDescr,
      //   details: {
      //     cultureType: 'Green House',
      //     country: 'Italie',
      //     rateCBD: '4-6%',
      //     rateTHC: '<0,3 %'
      //   },
      //   isFlorOrHasch: true
      // },
      // {
      //   id: 402,
      //   name: 'Lemoncello',
      //   categoryTitle: 'greenhouse',
      //   imageUrl: imgLimoncello,
      //   prices: [
      //     { value: 2.5, label: '1g (2,50€/g)' },
      //     { value: 12.5, label: '5g (2,50€/g)' },
      //     { value: 25.0, label: '10g (2,50€/g)' },
      //     { value: 56.25, label: '25g (2,25€/g)' },
      //     { value: 50.0, label: '50g (1,00€/g)' },
      //     { value: 100.0, label: '100g (1,00€/g)' }
      //   ],
      //   lowerPrice: 'A partir de 1,00€',
      //   mainDescription: mainDescription.LemoncelloDescr,
      //   details: {
      //     cultureType: 'Green House',
      //     country: 'Italie',
      //     rateCBD: '4-6%',
      //     rateTHC: '<0,3 %'
      //   },
      //   isFlorOrHasch: true
      // }
    ]
  },
  {
    title: 'hasch',
    imageFamily: imghaschfamily,
    items: [
      {
        id: 9,
        name: 'Marocain',
        imageUrl: imgMarocain,
        prices: [
          { value: 7.0, label: '1g (7,00€/g)' },
          { value: 30.0, label: '5g (6,00€/g)' },
          { value: 55.0, label: '10g (5,50€/g)' },
          { value: 125.0, label: '25g (5,00€/g)' },
          { value: 225.0, label: '50g (4,50€/g)' },
          { value: 400.0, label: '100g (4,00€/g)' }
        ],
        lowerPrice: 'A partir de 4,00€',
        mainDescription: mainDescription.marocainDescr,
        details: {
          cultureType: 'Extraction',
          country: 'Suisse',
          rateCBD: '40 %',
          rateTHC: '<0,3 %',
          taste: undefined
        },
        isFlorOrHasch: true
      },
      {
        id: 10,
        name: 'Pollen',
        imageUrl: imgPollen,
        prices: [
          { value: 6.0, label: '1g (6,00€/g)' },
          { value: 27.5, label: '5g (5,50€/g)' },
          { value: 50.0, label: '10g (5,00€/g)' },
          { value: 112.5, label: '25g (4,50€/g)' },
          { value: 200.0, label: '50g (4,00€/g)' },
          { value: 300.0, label: '100g (3,00€/g)' }
        ],
        lowerPrice: 'A partir de 3,00€',
        mainDescription: mainDescription.pollenDescr,
        details: {
          cultureType: 'Extraction',
          country: 'Suisse',
          rateCBD: '30 %',
          rateTHC: '<0,3 %',
          taste: undefined
        },
        isFlorOrHasch: true
      },
      {
        id: 11,
        name: 'Filtre',
        imageUrl: imgFiltre,
        prices: [
          { value: 8.0, label: '1g (8,00€/g)' },
          { value: 35.0, label: '5g (7,00€/g)' },
          { value: 60.0, label: '10g (6,00€/g)' },
          { value: 137.0, label: '25g (5,48€/g)' },
          { value: 250.0, label: '50g (5,00€/g)' },
          { value: 470.0, label: '100g (4,70€/g)' }
        ],
        lowerPrice: 'A partir de 4,70€',
        mainDescription: mainDescription.filtreDescr,
        details: {
          cultureType: 'Extraction',
          country: 'Suisse',
          rateCBD: '75 %',
          rateTHC: '<0,3 %',
          taste: undefined
        },
        isFlorOrHasch: true
      },
      {
        id: 12,
        name: 'Ice O lator',
        imageUrl: imgiceOLator,
        prices: [
          { value: 8.0, label: '1g (8,00€/g)' },
          { value: 35.0, label: '5g (7,00€/g)' },
          { value: 60.0, label: '10g (6,00€/g)' },
          { value: 137.0, label: '25g (5,48€/g)' },
          { value: 250.0, label: '50g (5,00€/g)' },
          { value: 470.0, label: '100g (4,70€/g)' }
        ],
        lowerPrice: 'A partir de 4,70€',
        mainDescription: mainDescription.iceOLatorDescr,
        details: {
          cultureType: 'Extraction',
          country: 'Suisse',
          rateCBD: '60 %',
          rateTHC: '<0,3 %',
          taste: undefined
        },
        isFlorOrHasch: true
      }
    ]
  }
];

export default SHOP_DATA;
